module.exports = __webpack_public_path__ + "static/media/smart.052c4bbc.png";